import { render, staticRenderFns } from "./NameDialog.vue?vue&type=template&id=72abc663&scoped=true&"
import script from "./NameDialog.vue?vue&type=script&lang=js&"
export * from "./NameDialog.vue?vue&type=script&lang=js&"
import style0 from "./NameDialog.vue?vue&type=style&index=0&id=72abc663&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72abc663",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72abc663')) {
      api.createRecord('72abc663', component.options)
    } else {
      api.reload('72abc663', component.options)
    }
    module.hot.accept("./NameDialog.vue?vue&type=template&id=72abc663&scoped=true&", function () {
      api.rerender('72abc663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/components/NameDialog.vue"
export default component.exports